export default __webpack_public_path__ + "static/media/2022 (1).ec4cb52f.jpg";